var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"as-resize-toolbar",style:(_vm.isVertical ? 'width: 100%;' : 'height: 100%')},[(_vm.showResize)?_c('div',{class:[
      _vm.isVertical ? 'vertical-resize-tool' : 'horizontal-resize-tool',
      _vm.resizeToolbarStyleType,
    ]}):_vm._e(),(_vm.showCollapse)?_c('zm-button',{staticClass:"collapse-button",staticStyle:{"color":"#131619"},attrs:{"icon":_vm.isCollapse ? 'zm-icon-right' : 'zm-icon-left',"size":"mini"},on:{"click":_vm.handleCollapse}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }